/**
 * @module use-cases/order/slice
 * @desc Order Slice (Reducers and ExtraReducers)
 *
 */

import { createSlice } from 'core/use-cases/utilities';
import { ORDER_PAYMENT_VIEWS, Utilities } from 'core/domains';
import type { Order } from 'core/domains';
import { PAYMENT_PLAN_TYPE } from 'core/services/bff';

import { getPaymentView, getPaymentViewCreditCard } from '../helpers';

import * as actions from './actions';
import { initialState } from './initial-state';

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(actions.orderCleanUp, () => initialState);

    builder.addCase(actions.orderFetch.request, (state) => {
      state.message = '';
      state.status = Utilities.STATUS.RUNNING;
    });

    builder.addCase(actions.orderFetch.success, (state, { meta, payload }) => {
      const { paymentMethod, payments } = payload;

      if (payments[0].name.toLowerCase().includes('pix')) {
        state.view = ORDER_PAYMENT_VIEWS.PIX;
        state.data = payload;
        state.status = Utilities.STATUS.SUCCESS;
        state.updatedAt = meta.updatedAt;
        return;
      }

      const mapperView = {
        [PAYMENT_PLAN_TYPE.CREDIT_CARD]: getPaymentViewCreditCard(payload),
        [PAYMENT_PLAN_TYPE.BANK_BILLING]: getPaymentView(payments),
        [PAYMENT_PLAN_TYPE.OTHER]: ORDER_PAYMENT_VIEWS.OTHER,
      };

      state.view = mapperView[paymentMethod as keyof typeof mapperView] || getPaymentView(payments);

      state.data = payload;
      state.status = Utilities.STATUS.SUCCESS;
      state.updatedAt = meta.updatedAt;
    });

    builder.addCase(actions.orderFetch.failure, (state, { error }) => {
      const { message } = error;

      state.data = {} as Order['data'];
      state.message = message;
      state.status = Utilities.STATUS.ERROR;
    });
  },
});

export const { reducer } = orderSlice;
export { actions };
